import React from "react";
import CompanyHeaderDetailsComponent from "../../components/CompanyHeaderDetails/CompanyHeaderDetails.component";
import CompanyRelatedDetailsComponent from "../../components/CompanyRelatedDetails/CompanyRelatedDetails.component";

const CompaniesContainer = (props) => {
  return (
    <React.Fragment>
      <CompanyHeaderDetailsComponent {...props}></CompanyHeaderDetailsComponent>
      <CompanyRelatedDetailsComponent />
    </React.Fragment>
  );
};

export default CompaniesContainer;
